import type {EvaluatorOptions} from "./evaluator-options.js";
import type {TS} from "../../type/ts.js";

/**
 * Evaluates, or attempts to evaluate, a TypeAliasDeclaration
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function evaluateTypeAliasDeclaration(_options: EvaluatorOptions<TS.TypeAliasDeclaration>): void {
	return;
}
